import gql from 'graphql-tag'

export const BANNER_SEND_FORM = gql`
  mutation sendPromocode($email: String!, $token: String!) {
    sendPromocode(email: $email, token: $token) {
      success
      message
    }
  }
`

export const DISMISS_PROMOCODE = gql`
  mutation dismissPromocode {
    dismissPromocode
  }
`
